module.exports = __webpack_public_path__ + "img/logo_cafam_small.eeadbe59.png";